import { Injectable, inject } from '@angular/core';
import { HttpBaseService } from '../base_services/http_base.service';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpClient } from '@angular/common/http';
import { iif, Observable, of, tap } from 'rxjs';
import { TServiceResult } from '@shared/helper/t-service-result';
import { IGetCategoryDto, IGetCategoryTree } from '@shared/model/category/category.model';
import { ISelectedCategoryDto } from '@shared/model/category/selected-category.model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { CATEGORY_DATA } from 'constants/storage-keys';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends HttpBaseService {
  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'ctg');
  }


  getAllCategories(): Observable<TServiceResult<IGetCategoryDto[]>> {
    const categoryRawData = this.Repository.getLocalItem(CATEGORY_DATA);
    const categoryCachedData = categoryRawData ? JSON.parse(categoryRawData) : null;
    return iif(() => !!categoryCachedData, of(categoryCachedData),
      this.http.get<TServiceResult<IGetCategoryDto[]>>(`${this.apiUrl}/GetAll`).pipe(
        tap(res => {
          if (!res.hasError)
            this.Repository.setLocalItem(CATEGORY_DATA, JSON.stringify(res));
        }))
    );
  }

  getCategoryTree(): Observable<TServiceResult<IGetCategoryTree[]>> {
    return this.http.get<TServiceResult<IGetCategoryTree[]>>(`${this.apiUrl}/Menu`);
  }

  getSelectedCategories(): Observable<TServiceResult<PageList<ISelectedCategoryDto>>> {
    return this.http.get<TServiceResult<PageList<ISelectedCategoryDto>>>(`${this.apiUrl}/getSelectedCategories`)
  }

  setFavoriteCategories(categoryIds: string[]): Observable<TServiceResult<boolean>> {
    return this.http.post<TServiceResult<boolean>>(`${this.apiUrl}/setFavoriteCategories`, categoryIds)
  }

}
